// Steps/Confirm.js

import {useForm} from "react-hook-form";
import {useAppState} from "../state";
import {Button, Field, Form, Input, Section, SectionRow, Errors} from "../Forms";
import {Link, useNavigate} from "react-router-dom";
import axios from "axios";
import React, {useState} from "react";

export const Confirm = () => {
    const [state, setState] = useAppState();
    const [isLoading, setIsLoading] = useState(false);
    const navigate = useNavigate();
    const {
        handleSubmit,
        register,
        formState: {errors},
    } = useForm({defaultValues: state, mode: "onSubmit"});

    const submitData = (data) => {
        setIsLoading(true);
        setState({...state, ...data});

        axios.post("/wp-json/Qlic/v1/exhibitor/insert", {
            data: data
        })
        .catch((e) => {
            setIsLoading(true);
        })
        .then((response) => {
            if (response.data.status) {
                window.location.href = response.data.return_url;

                setIsLoading(false);
            }
        });
    };

    const isSurfaceActive = () => {
        if (state.options[state.stand].add_surface == false) {
            return false;
        }

        if (state.surface == '') {
            return false;
        }

        return true;
    }


    const getSquare = (event) => {
        const square = stands.find(obj => {
            return obj.id === parseInt(state.square);
        });

        return square.title;
    }

    const getBranches = (event) => {
        const branche = branches.find(obj => {
            return obj.id === parseInt(state.branche);
        });

        return branche.title;
    }

    return (
        <div className="checkout__form__step" data-form="3">
            <Form onSubmit={handleSubmit(submitData)}>
                <div className="row gx-4 gy-4">
                    <div className="col-12 col-lg-7 order-1">
                        <div className="summary">
                            <div className="summary__content">
                                <h4>Stand</h4>
                                <div className="summary__items">
                                    <div className="summary__items__item">
                                        <div className="summary__items__item-label">Plein:</div>
                                        <div className="summary__items__item-value">{getSquare()}</div>
                                    </div>
                                    {isSurfaceActive() ?
                                        <div className="summary__items__item">
                                            <div className="summary__items__item-label">Oppervlakte:</div>
                                            <div className="summary__items__item-value">{state.surface}m&#178;</div>
                                        </div>
                                    : ''}
                                    <div className="summary__items__item">
                                        <div className="summary__items__item-label">Type standbouw:</div>
                                        <div className="summary__items__item-value">{state.options[state.stand].title}</div>
                                    </div>
                                    <div className="summary__items__item">
                                        <div className="summary__items__item-label">Prijs:</div>
                                        <div className="summary__items__item-value">{state.options[state.stand].price}</div>
                                    </div>
                                    {state.options[state.stand].contribution ?
                                        <div className="summary__items__item">
                                            <div className="summary__items__item-label">Contributie:</div>
                                            <div className="summary__items__item-value">{state.options[state.stand].contribution}</div>
                                        </div>
                                    : ''}
                                    {state.specialNotes !== '' ?
                                        <div className="summary__items__item">
                                            <div className="summary__items__item-label">Bijzonderheden:</div>
                                            <div className="summary__items__item-value">{state.specialNotes}</div>
                                        </div>
                                        : ''}
                                </div>

                                {state.selectedExpansions && state.selectedExpansions.length > 0 ? (
                                    <div>
                                        <div className="summary__items mt-4">
                                            <h5>Uitbreidingen</h5>
                                            {state.selectedExpansions.map((expansion, idx) => (
                                                <div className="summary__items__item" key={idx}>
                                                    <div className="summary__items__item-label">{expansion.title}:</div>
                                                    <div className="summary__items__item-value">€ {expansion.price},-</div>
                                                </div>
                                            ))}
                                        </div>
                                        <div className="summary__items__item summary__items__total">
                                            <div className="summary__items__item-label">Totaalprijs:</div>
                                            <div className="summary__items__item-value">€ {state.totalPrice},-</div>
                                        </div>
                                    </div>
                                ) : null}



                            </div>
                            <div className="summary__bottom d-flex justify-content-end">
                                <Link to='/'>Stand wijzigen<i className="fa-regular fa-pen-to-square"></i></Link>
                            </div>
                        </div>
                    </div>
                    <div className="col-12 col-lg-5 order-4 order-lg-2">
                        <div className="c2a">
                            <div className="c2a__icon">

                            </div>
                            <h5>Kom je er niet uit?</h5>
                            <ul className="clean">
                                <li><a href="tel:+31505258999"><i className="fa-solid fa-phone"></i>050 525 8999</a></li>
                                <li><a href="mailto:info@promotiedagen.nl"><i className="fa-solid fa-envelope"></i>info@promotiedagen.nl</a></li>
                            </ul>
                            <div className="questions">
                                <div className="questions__item">
                                    <a href="https://www.promotiedagen.nl/praktisch/contact-faq/" target="_blank">
                                        Contact/FAQ <i className="fa-regular fa-arrow-right-long"></i>
                                        <span>Neem contact met ons op</span>
                                    </a>
                                </div>
                            </div>
                        </div>
                    </div>
                    <div className="col-12 order-3">
                        <div className="summary">
                            <div className="summary__content">
                                <h4>Contactgegevens</h4>
                                <div className="summary__items mb-4">
                                    <div className="summary__items__item">
                                        <div className="summary__items__item-label">Contactpersoon:</div>
                                        <div className="summary__items__item-value">{state.name}</div>
                                    </div>
                                    <div className="summary__items__item">
                                        <div className="summary__items__item-label">Functie:</div>
                                        <div className="summary__items__item-value">{state.function}</div>
                                    </div>
                                    <div className="summary__items__item">
                                        <div className="summary__items__item-label">Telefoon:</div>
                                        <div className="summary__items__item-value">{state.phone}</div>
                                    </div>
                                    <div className="summary__items__item">
                                        <div className="summary__items__item-label">E-mailadres:</div>
                                        <div className="summary__items__item-value">{state.email}</div>
                                    </div>
                                </div>
                                <h4>Bedrijfsgegevens</h4>
                                <div className="summary__items mb-4">
                                    <div className="summary__items__item">
                                        <div className="summary__items__item-label">Bedrijfsnaam:</div>
                                        <div className="summary__items__item-value">{state.companyName}</div>
                                    </div>
                                    <div className="summary__items__item">
                                        <div className="summary__items__item-label">Adres:</div>
                                        <div className="summary__items__item-value">
                                            {state.street} {state.houseNumber}<br/>
                                            {state.postalCode} {state.city}
                                        </div>
                                    </div>
                                    {state.invoiceAddress ?
                                        <div className="summary__items__item">
                                            <div className="summary__items__item-label">Afwijkend adres:</div>
                                            <div className="summary__items__item-value">
                                                {state.invoiceEmail}<br/>
                                                {state.invoiceStreet} {state.invoiceHouseNumber}<br/>
                                                {state.invoicePostalCode} {state.invoiceCity}
                                            </div>
                                        </div>
                                    : ''}
                                    <div className="summary__items__item">
                                        <div className="summary__items__item-label">Algemeen telefoonnummer:</div>
                                        <div className="summary__items__item-value">{state.companyPhone}</div>
                                    </div>
                                    <div className="summary__items__item">
                                        <div className="summary__items__item-label">Algemeen e-mailadres:</div>
                                        <div className="summary__items__item-value">{state.companyEmail}</div>
                                    </div>
                                    <div className="summary__items__item">
                                        <div className="summary__items__item-label">Website:</div>
                                        <div className="summary__items__item-value">{state.website}</div>
                                    </div>
                                    <div className="summary__items__item">
                                        <div className="summary__items__item-label">Branche(s):</div>
                                        <div className="summary__items__item-value">{getBranches()}</div>
                                    </div>
                                    <div className="summary__items__item">
                                        <div className="summary__items__item-label">Bedrijfsactiviteit:</div>
                                        <div className="summary__items__item-value">{state.companyActivity}</div>
                                    </div>
                                </div>
                            </div>
                            <div className="summary__bottom d-flex justify-content-end">
                                <Link to='/gegevens'>Gegevens wijzigen<i
                                    className="fa-regular fa-pen-to-square"></i></Link>
                            </div>
                        </div>
                    </div>
                </div>
                <div className="row mt-4">
                    <div className="col-12">
                        <Field label="Ik ontvang graag de nieuwsbrief" error={errors?.newsletter} className="box__input">
                            <Input
                                {...register("newsletter")}
                                id="newsletter" type='checkbox'
                            />
                        </Field>
                    </div>

                    <div className="col-12">
                        <div className="form__field box__input">
                            <Input
                                {...register("terms", { required: "U dient akkoord te gaan met het privacy statement." })}
                                id="terms" type='checkbox'
                            />
                            <label htmlFor="terms">Ik ga akkoord met het <a href='https://www.promotiedagen.nl/wp-content/uploads/2023/07/Privacy-Statement.pdf' target='_blank'>privacy statement</a> <span className="required">*</span></label>
                            {errors.terms && <small className="error">U dient akkoord te gaan met het privacy statement.</small>}
                        </div>
                    </div>
                </div>
                <div className="checkout__form__actions d-flex align-items-center justify-content-between mt-4">
                    <Link to="/gegevens">
                        Vorige stap
                    </Link>
                    <Button disabled={isLoading}>Inschrijving verzenden</Button>
                </div>
            </Form>
        </div>
    );
};
